"use strict";

(function (global) {
  /** Список поисковых режимов. */
  const searchModes = ['search', 'placedin', 'attachedtotask', 'lastobjects'];

  global.toolbarWidth = 0;

  /**
  * Поиск родительской папки в переданной части URL
  * @since 5.0.0.7300
  * @function Core.toolBars.main.getSourceId
  */
  global.getSourceId = function () {
    return (new WA.URL()).getParam('opener');
  };

  /**
  * Активирует кнопку 'Удалить ссылку', если есть id родительской папки
  * @since 5.0.0.7300
  * @function Core.toolBars.main.enableDeleteButton
  */
  global.enableDeleteButton = function (toolItem) {
    //if (global.getSourceId()) toolItem.enable();
  };

  /**
  * Действие для кнопки 'Удалить ссылку' в карточках объектов
  * @since 5.0.1.1700
  * @function Core.toolBars.main.deleteLinkFromCard
  */
  global.deleteLinkFromCard = WA.TCD(() => {
    let link = new WA.Link();
    const sourceId = global.getSourceId();

    if (WA.isMobile()) {
      const params = { 
        Links: [link.toLinkModel()], 
        SourceID: sourceId, 
        SourceType: 'FOLDER',
        UnselectedLinks: [],
      };
      WA.SRV.call('/Session.asmx/DeleteLinks', params).done((res) => {
        CloseJobWindow(WA.CR.getID);
      });
      return this;
    };

    let toast = new WA.CMP.notifications.Toast();

    ConfirmDelete(1, L('CONFIRM_DELETE_LINK_FROM_INBOX')).done(() => {
      let params = { 
        Links: [link.toLinkModel()], 
        SourceID: sourceId,
        SourceType: 'FOLDER',
        UnselectedLinks: [],
      };
      WA.SRV.call('/Session.asmx/DeleteLinks', params).done((res) => {
        if (res != 0) {
          var opener = window.opener;
          if (opener) {
            if (opener.WA.getLocation() === 'explorer') {
              opener.WA.CR.objectList.reload().done(() => {
                if (opener.WA.CR.folderTree) {
                  opener.WA.CR.folderTree.updateNodesWithFolder(opener.WA.CR.getID());
                }                
              });
              opener.updateChkAll($('div.object_contents'), $('#chkAll'));
              opener.UpdateCopyPasteIcons();
              toast.show(L('DELETED_LINKS', res));
              opener.EnableOrDisableCheckAll();
            };
          };
        } else {
          toast.show(L("CANNOT_DELETE_LINK"));
        }
        WA.CR.window.close(this);
      });
    });

    return this;
  });

  /**
  * Действие для кнопки 'Создать папку'
  * @since 5.0.0.7300
  * @function Core.toolBars.main.createFolder
  */
  global.createFolder = function () {
    var folderId = WA.CR.getID() || FavoritesFolderID;
    var folderTab = (new WA.URL('/PleaseWait.aspx')).open();

    //IOS замораживает вкладки, которые висят в фоне, поэтому фабрики в нем отдыхают
    if (WA.ENV.os.name.toLowerCase() === 'ios') {
      (new WA.URL('/Folder.aspx')).setParam('mode', 'new').setParam('path', folderId).openIn(folderTab);
      return global;
    }

    //Во всех нормальных браузерах можно пользоваться фабриками
    WA.FC.folders.createFolder({
      'pasteToFolder': folderId
    }).done(function (folder) {
      folder.toURL().setParam('folder', folderId).openIn(folderTab);
    }).fail(function () {
      folderTab.close();
    });
    return global;
  },

  /**
  * Действие для кнопки 'Создать задачу' и 'Отравить вложением'
  * @since 5.0.0.7300
  * @function Core.toolBars.main.createTask
  */
  global.createTask = function (opt_withoutAttachments) {
    var folderId = WA.CR.getID() || OutboxFolderID;

    if (opt_withoutAttachments === true) {
      _createTask([]);
      return;
    }

    var handled = false;
    var $list = $('.object_contents.auto_load');

    if (isAllRecordsInFolderSelected() && $list.length) {
      // выделены все объекты
      // есть автоподгрузка - нужен специальный метод
      if ($list.data('component') == 'FolderContents') {
        // работаем с папкой
        handled = true;
        WA.SRV.call("/Session.asmx/GetAllLinksFolder", { FolderID: folderId }).done(function (links) {
          links = $.map(links, function (model) { return (new WA.Link()).fromLinkModel(model); });
          _createTask(links);
        });
      } else {
        // работаем с результатами поиска
        // может быть очень много найденных элементов, поэтому отправлять задачу со всеми ими не будем.
        WA.CR.inlineHint.showError(L('ERR_CANNOT_SEND_ALL_THE_SEARCH_RESULTS_AS_AN_ATTACHMENT'));
      }
    } else {
      _createTask($.map(GetSelectedObjects(), function (q) { return new WA.Link(q.id, objectKindToObjectType(q.kind), q.refcode) }));
    }

    /**
    * Непосредственно создание задачи
    * @inner
    */
    function _createTask(attachments) {
      var taskTab = (new WA.URL('/PleaseWait.aspx')).setParam("message", L("PLEASE_WAIT_TASK")).open();

      //IOS замораживает вкладки, которые висят в фоне, поэтому к сожалению фабрики в нем отдыхают
      if (WA.ENV.os.name.toLowerCase() === 'ios') {
        if (attachments.length) {
          attachments = $.map(GetSelectedObjects(), function (q) { return { ID: q.id, Kind: q.kind, CompCode: q.refcode } });
          WA.SRV.callSync("/Task.asmx/CreateTaskWithAttachments", { Attachments: attachments }).done(function (id) {
            (new WA.URL("Task.aspx?view=Card&mode=edit")).setParam("id", id).openIn(taskTab);
          });
          return;
        }
        (new WA.URL('/Task.aspx')).setParam('mode', 'new').setParam('folder', folderId).openIn(taskTab);
        return;
      }

      //Во всех нормальных браузерах можно пользоваться фабриками
      WA.FC.tasks.createTask({
        attachments: attachments
      }).done(function (task) {
        task.toURL().setParam('folder', folderId).openIn(taskTab);
      }).fail(function () {
        taskTab.close();
      });
    }
  };

  /**
  * Данная функция вызывается серверной логикой, которая сначала формирует словарь buttons в следующем формате:
  * init({
  * ‘Btn1’: function() { try {
  *    DisableIfNotEq1(this);
  * } catch(ex) { ShowError(ex.message); }; },
  * ‘Btn2’: function() { try {
  *    DisableIfNotEq1(this, ‘SomeParam1’, ‘SomeParam2’)
  * } catch(ex) { ShowError(ex.message); }; },
  *});
  * затем все эти функции последовательно запускаются.
  * функции указываются в расширениях ВД, для каждой отдельной кнопки в атрибуте oninit
  *
  * @since 5.0.0.4102
  * @function Core.toolBars.main.init
  * @param {[type]} buttons [description]
  */
  global.init = function (buttons) {
    $.when(WA.ToolBarInit).done(function () {
      for (const button in buttons) {
        if (WA.current.toolBar.buttons[button]) {
          buttons[button].apply(WA.current.toolBar.buttons[button]);
        }
      }
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Сбросить состояние тулбара. Для списка переданных кнопок заменяет состояние, для всех остальных - сбрасывает.
   *
   * @param {array} states Список состояний кнопок, которые нужно заменить.
   * @function Core.toolBars.main.reset
   */
  global.reset = function (states) {
    _.each(WA.CR.toolBar.buttons.toArray(), function (button) {
      var isDisabled, isSelected;
      var jButton = button._jObject;
      var state = _.find(states, function (el) { return el.name === button.name; });
      if (state) {
        isDisabled = state.isDisabled;
        isSelected = state.isSelected;
      }
      if (typeof isDisabled === 'undefined')
        isDisabled = jButton.data('disabled');
      if (typeof isSelected === 'undefined')
        isSelected = jButton.data('selected');

      isDisabled ? button.disable() : button.enable();
      isSelected ? button.select() : button.unSelect();
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует кнопку тулбара, если в списке объектов выделено только [count] записей.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.enableButtonOnItemsSelect
  */
  global.enableButtonOnItemsSelect = function (toolItem, count) {
    $.when(WA.ObjectListInit).done(function () {
      WA.current.objectList
        .bind('onSelect', function (last, allItems) {
          if (allItems.length === count) toolItem.enable();
          else toolItem.disable();
        })
        .bind("onChange", function (selectedItems, allItems) {
          if (selectedItems.length === count) toolItem.enable();
          else toolItem.disable();
        });
    });

    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует кнопку тулбара, если в списке объектов выделена более count записей.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.enableButtonOnItemsSelectGt
  */
  global.enableButtonOnItemsSelectGt = function (toolItem, count) {
    $.when(WA.ObjectListInit).done(function () {
      WA.current.objectList
        .bind('onSelect', function (last, allItems) {
          if (allItems.length > count) toolItem.enable();
          else toolItem.disable();
        })
        .bind("onChange", function (selectedItems, allItems) {
          if (selectedItems.length > count) toolItem.enable();
          else toolItem.disable();
        });
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует галочку выделения всех записей,
  * если в списке объектов выделена более count записей.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.enableCheckBoxOnItemsSelect
  */
  global.enableCheckBoxOnItemsSelect = function () {
    let jCheckAll = $('#chkAll');
    $.when(WA.ObjectListInit).done(() => {
      WA.current.objectList.bind('onSelect', (last, allItems) => {
        jCheckAll.prop('checked', !!allItems.length);
      });
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие callback для первого веделенного элемента.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.processFirstSelectedItem
  */
  global.processFirstSelectedItem = function (callback) {
    var items = WA.CR.objectList.getSelectedItems();
    if (items.length > 0) {
      var item = items[0];
      if ($.isFunction(callback)) callback.call(this, { id: item.id, kind: item.kind, refcode: item.referenceCode });
    };
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие callback для текущего открытого объекта.
  * @since 5.0.0.4216
  * @function Core.toolBars.main.processCurrentObject
  */
  global.processCurrentObject = function (callback) {
    // Находимся в карточке.
    var kind = WA.CR.getKind();
    if (!!kind && $.isFunction(callback)) {
      callback.call(this, {
        id: WA.CR.getID(),
        kind: kind,
        refcode: WA.CR.getReferenceCode()
      });
    };
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует кнопку "Открыть карточку" и меняет название группы "Объект".
  * @since 5.0.0.4219
  * @function Core.toolBars.main.enableObjectCardBtn
  */
  global.enableObjectCardBtn = function (toolItem) {
    if (toolItem.groupName === 'TOOLBAR_ACTIONS_WITH_OBJECT_GROUP') {
      $.when(WA.ToolBarInit).done(function () {
        var mode = GetParamInURL('mode').toLowerCase();
        if (mode == 'search') {
          var searchName = GetParamInURL('searchname').toLowerCase();
          var groupName;
          switch (searchName) {
            case 'srchdoc': groupName = 'TOOLBAR_ACTIONS_WITH_DOCUMENT_GROUP'; break;
            case 'srchjob': groupName = 'TOOLBAR_ACTIONS_WITH_JOB_GROUP'; break;
            case 'srchtask': groupName = 'TOOLBAR_ACTIONS_WITH_TASK_GROUP'; break;
            default: groupName = 'TOOLBAR_ACTIONS_WITH_OBJECT_GROUP';
          }
        } else if (mode == 'attachedtotask') {
          groupName = 'TOOLBAR_ACTIONS_WITH_TASK_GROUP';
        } else {
          groupName = 'TOOLBAR_ACTIONS_WITH_OBJECT_GROUP';
        }
        WA.current.toolBar.groups.TOOLBAR_ACTIONS_WITH_OBJECT_GROUP.setLabel(L(groupName));
      });
    }
    return global.enableButtonOnItemsSelect(toolItem, 1);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


  /**
  * Выполняет действие "Открыть карточку".
  * @since 5.0.0.4200
  * @function Core.toolBars.main.openObjectCard
  */
  global.openObjectCard = function () {
    Core.toolBars.main.processFirstSelectedItem(ShowObjectCard);
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
 * Выполняет действие "Копировать объект".
 * @since 5.0.0.4200
 * @function Core.toolBars.main.copyObject
 */
  global.copyObject = function () {
    Core.toolBars.main.processFirstSelectedItem(function (proxy) {
      switch (proxy.kind.toLowerCase()) {
        case 'edoc':
          proxy.tr = $('#' + proxy.id);
          EDocument(proxy).CopyDoc();
          break;
        case 'ref':
          Reference_CopyRecord(proxy.refcode, proxy.id)
          break;
        default:
          ShowError(L('ERR_UNSUPPORTED_METHOD'));
      }
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует кнопку, если выбран документ или запись справочника (используется для кнопок "Копировать объект" и "Связанные документы").
  * @since 5.0.0.4207
  * @function Core.toolBars.main.enableButtonForDocOrRefRecord
  */
  global.enableButtonForDocOrRefRecord = function (toolItem) {
    $.when(WA.ObjectListInit).done(function () {
      WA.current.objectList.bind('onSelect', function (last, allItems) {
        if (allItems.length === 1) {
          Core.toolBars.main.processFirstSelectedItem(function (proxy) {
            var kindLowered = proxy.kind.toLowerCase();
            // Копирвоание обеъекта работает только для документа и записи справочника.
            if (kindLowered === 'edoc' || kindLowered === 'ref') {
              toolItem.enable();
            } else {
              toolItem.disable();
            }
          });
        } else {
          toolItem.disable();
        }
      });
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие "История".
  * @since 5.0.0.4200
  * @function Core.toolBars.main.openObjectHistory
  */
  global.openObjectHistory = function () {
    Core.toolBars.main.processFirstSelectedItem(function (proxy) {
      ShowObjectCard(proxy, 'view=History&mode=read');
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие "Вложено в задачи".
  * @since 5.0.0.4200
  * @function Core.toolBars.main.showAttachedToTasks
  */
  global.showAttachedToTasks = function () {
    Core.toolBars.main.processFirstSelectedItem(function (proxy) {
      var lowerKind = proxy.kind.toLowerCase();
      if (lowerKind === 'edoc' || lowerKind === 'ref') {
        // Открываем в карточке.
        ShowObjectCard(proxy, 'view=AttachedTasks');
      } else {
        //Открывается в проводнике.
        ShowAttachedToTasks(proxy);
      };
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие "Находится в папках".
  * @since 5.0.0.4200
  * @function Core.toolBars.main.showInsideFolders
  */
  global.showInsideFolders = function () {
    Core.toolBars.main.processFirstSelectedItem(function (proxy) {
      var lowerKind = proxy.kind.toLowerCase();
      if (lowerKind === 'edoc') {
        // Открываем в карточке.
        ShowObjectCard(proxy, 'view=PlacedInFolders');
      } else {
        //Открывается в проводнике.
        ShowInsideFolders(proxy);
      };
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие "Связанные документы".
  * @since 5.0.0.4207
  * @function Core.toolBars.main.showBoundDocuments
  */
  global.showBoundDocuments = function () {
    Core.toolBars.main.processFirstSelectedItem(function (proxy) {
      ShowObjectCard(proxy, 'view=BoundDocuments')
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие "Связанные документы".
  * @since 5.0.0.4207
  * @function Core.toolBars.main.showBoundDocuments
  */
  global.showBoundDocuments = function () {
    Core.toolBars.main.processFirstSelectedItem(function (proxy) {
      ShowObjectCard(proxy, 'view=BoundDocuments')
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Отправляет объект proxy вложением.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.sendAsAttachment
  */
  global.sendAsAttachment = function (proxy) {
    window.WA.services.task.createTaskWithAttachments([{ 'ID': proxy.id, 'Kind': proxy.kind, 'CompCode': proxy.refcode }]).success(function (res) {
      window.open("Task.aspx?view=Card&mode=edit&id=" + res, "task" + res);
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Открывает содержимое папки, переданной в виде прокси объекта.
  * @since 5.2.0.2006
  * @function Core.toolBars.main.openFolderContent
  */
  global.openFolderContent = function (proxy) {
    if (proxy.kind == 'FOL') {
      var folderContentUrl = "";
      if (!$.isEmptyObject(WA.EXT))
        folderContentUrl = "explorer.aspx?ext=" + WA.EXT.current.name + "&ID=" + proxy.id;
      else
        folderContentUrl = "explorer.aspx?ID=" + proxy.id;
      window.open(folderContentUrl);
    }
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Проверяет находимся ли мы в режиме поиска в проводнике или нет.
  * @since 5.0.0.4206
  * @function Core.toolBars.main.isSearchMode
  */
  global.isSearchMode = function () {
    let mode = GetParamInURL('mode').toLowerCase();
    return searchModes.includes(mode);
  };

  /**
  * Проверяет находимся ли мы в режиме интегрированного поиска (поиск по связи с объектом) в проводнике или нет.
  * @since 5.0.0.4206
  * @function Core.toolBars.main.isIntegratedSearchMode
  */
  global.isIntegratedSearchMode = function () {
    var mode = GetParamInURL('mode').toLowerCase();
    return (mode === 'placedin' || mode === 'attachedtotask');
  };

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Проверяет выделен ли объект во втором уровне иерархии?
  * @since 5.0.0.4212
  */
  var isSelectedSecondLevelInRelationTree = function () {
    if (WA.ObjectListInit.state() === "resolved" && !!WA.CR.objectList) {
      var items = WA.current.objectList.getSelectedItems();
      for (var i = 0; i < items.length; i++) {
        if (items[i]._jObject.parents('.SubBounds').length > 0) {
          return true;
        }
      }
    }
    return false;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует кнопки "Вырезать ссылки" и "Удалить ссылки".
  * @since 5.0.0.4203
  * @function Core.toolBars.main.enableCutAndDeleteLinksBtn
  */
  global.enableCutAndDeleteLinksBtn = (toolItem) => {
    $.when(WA.ObjectListInit).done(() => {
      let isSelectedSecondLevelItem = isSelectedSecondLevelInRelationTree();
      WA.current.objectList.bind('onSelect', (last, allItems) => {
        if (!global.isSearchMode() && allItems.length && !isSelectedSecondLevelItem) {
          toolItem.enable();
        } else {
          toolItem.disable();
        }
      });
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует/деактивирует кнопку "Вставить ссылки" при наступлении события смены папки.
  * @since 5.5.0.9067
  * @function Core.toolBars.main.enablePasteLinksBtnOnFolderChange
  */
  global.enablePasteLinksBtnOnFolderChange = function (toolItem) {
    WA.current.objectList.bind('onChange', function () {
      Core.toolBars.main.enablePasteLinksBtn(this);
    }, toolItem);
    Core.toolBars.main.enablePasteLinksBtn(toolItem);
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует/деактивирует кнопку "Вставить ссылки".
  * @since 5.0.0.4203
  * @function Core.toolBars.main.enablePasteLinksBtn
  */
  global.enablePasteLinksBtn = function (toolItem) {
    var isSearch = global.isSearchMode();
    var currFolIsReadolny = $('#CurrentFolderIsReadonlyRights').val() === 'True';
    if (isSearch || currFolIsReadolny) {
      toolItem.disable();
    } else {
      toolItem.enable();
    }
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Действие на кнопку "Вставить ссылки" во вкладке "Связанные документы".
  * @since 5.0.0.4216
  * @function Core.toolBars.main.pasteBoundsInTab
  */
  global.pasteBoundsInTab = function (toolItem) {
    var id = WA.current.getID();

    if (WA.getLocation() == "doc") {
      PasteLinks('EDOCUMENT', '' + id);
    } else if (WA.getLocation() == "reference") {
      BindToRecord('' + id, WA.current.getReferenceCode());
    }

    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Действие на кнопку "Удалить ссылки" во вкладке "Связанные документы".
  * @since 5.0.0.4216
  * @function Core.toolBars.main.deleteBoundsInTab
  */
  global.deleteBoundsInTab = function (toolItem) {
    var id = WA.current.getID();

    if (WA.getLocation() == "doc") {
      DeleteLinks('&amp;docid=' + id);
    } else if (WA.getLocation() == "reference") {
      UnBindFromRecord('' + id, WA.current.getReferenceCode());
    }

    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Делает не активной кнопку "Отправить задачей", если открыта папка "Ярлыки".
  * @since 5.1.0.1518
  * @function Core.toolBars.main.enableSendAsTaskAttachment
  */
  global.enableSendAsTaskAttachment = function (toolItem) {
    if (WA.CR.getKind() === 'FOL' && WA.CR.FolderType === FOLDER_TYPE.SHORTCUTS || WA.CR.IsNew) {
      toolItem.disable();
    } else {
      toolItem.enable();
    };
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Действие на кнопку "Создать и вложить" в карточках ЗЗУ.
  * @since 5.1.0.1522
  * @function Core.toolBars.main.createAndAttach
  */
  global.createAndAttach = function () {
    let popup;
    let windowName;
    const dialog = new WA.CMP.dialogs.CreateDocument();
    dialog.bind('loaded', data => {
      // Изменяем имя папки на имя ЗЗУ, в которую будет вставлен документ.
      $('#pasteInLabel').text(L('ATTACH_IN'));
      $('#new_txtFolder').text($('.card-header__label').text().trunc(50));
    });
    dialog.bind('ok', data => {
      const pleaseWait = new WA.URL('/PleaseWait.aspx');
      pleaseWait.setParam('message', L('PLEASE_WAIT_EDOCUMENT'));
      const rnd = Math.floor(Math.random() * 10000).toString();
      popup = pleaseWait.open('wnd' + rnd);
      windowName = 'wnd' + rnd;
    });
    dialog.bind('createMulti', documents => {
      documents.forEach(document => {
        const docUrl = document.toURL();
        docUrl.setParam('mode', 'new');
        docUrl.setParam('cwid', WA.CR.ID);
        docUrl.setParam('cwtype', WA.getLocation());
        docUrl.open(windowName);
        windowName = '';
      });
    });
    dialog.bind('error', message => {
      popup.close();
    })
    dialog.show()

    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует кнопку тулбара, если в списке объектов выделена хотя бы она запись с заданным типом.
  * @since 5.5.0.9000
  * @function Core.toolBars.main.enableButtonOnJobSelected
  */
  global.enableButtonOnObjectTypeSelected = function (toolItem, type) {
    $.when(WA.ObjectListInit).done(function () {
      WA.current.objectList
        .bind('onSelect', function (last, allItems) {
          var objects = allItems.filter(function (value) { return value.kind === type });
          if (objects.length > 0 && objects.length === allItems.length) {
            toolItem.enable();
          }
          else
            toolItem.disable();
        })
        .bind("onChange", function (selectedItems, allItems) {
          var objects = selectedItems.filter(function (value) { return value.kind === type });
          if (objects.length > 0 && objects.length === allItems.length) {
            toolItem.enable();
          }
          else
            toolItem.disable();
        });
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.Core.toolBars.main);
